// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3IhK4","select":"Header_select__2pair","clinic":"Header_clinic__2REXf"};